import { getInventoryType } from 'minecraft-inventory/src/registry'
import type { InventoryTypeDefinition } from 'minecraft-inventory/src/types'

export function inventoryDefinition(window: { type: string | number; inventoryStart: number } | null): InventoryTypeDefinition {
  if (!window) return getInventoryType('player')!
  let type = String(window.type)
  if (type === 'minecraft:container') type = `generic_9x${Math.min(6, Math.max(1, window.inventoryStart / 9))}`
  if (type === 'minecraft:shulker_box') type = 'chest'
  return getInventoryType(type) ?? getInventoryType(`generic_9x${Math.min(6, Math.max(1, Math.ceil(window.inventoryStart / 9)))}`)!
}

export const inventoryView = { x: 160, y: 122, scale: 4 }
export function nativeInventorySlotAt(x: number, y: number, definition: InventoryTypeDefinition) {
  x = (x - inventoryView.x) / inventoryView.scale
  y = (y - inventoryView.y) / inventoryView.scale
  return definition.slots.find(slot => x >= slot.x && x < slot.x + (slot.size ?? 18) && y >= slot.y && y < slot.y + (slot.size ?? 18))?.index ?? null
}

